/**
 * Grupos de afinidad (Oracle GRUPO_AFI).
 *
 * Servicio único para todas las pantallas que los necesitan
 * (Parámetros de Adelantos, Parámetros de Préstamos, etc.).
 * IntraNode: GET /grupos-afinidad → API: GET /jwt/gruposAfinidad
 */

import ApiService from "../apiService";

/**
 * Normaliza la respuesta a [{ id, nombre }].
 * Acepta responseHandler ({ data: [...] }) y el formato legacy ({ result: [...] }).
 */
export function normalizarGrupos(res) {
  const body = res?.data ?? res;
  const lista = [body?.data, body?.result, body].find(Array.isArray) ?? [];
  return lista
    .map((g) => ({
      id: g.ID ?? g.id ?? g.id_grupo_afinidad ?? g.idGrupoAfinidad,
      nombre: g.NOMBRE ?? g.nombre ?? g.name ?? "",
    }))
    .filter((g) => g.id !== undefined && g.id !== null);
}

const GruposAfinidadService = {
  /** Devuelve [{ id, nombre }] */
  getAll: async () => normalizarGrupos(await ApiService.get("/grupos-afinidad")),
};

export default GruposAfinidadService;
